import React, { Component } from 'react'
import { Link } from 'react-router'
import _map from 'lodash/map'
import Accordion from 'components/shared/Accordion'
import { makeDefaultFailedContainer } from 'components/container'
import { renderLogoSVG } from '../helpers'
import styles from './style.styl'

import DrupalInstaller from '../services/DrupalInstaller'
import WordPressInstaller from '../services/WordPressInstaller'
import JavaScriptInstaller from '../services/JavaScriptInstaller'
import HubSpotInstaller from '../services/HubSpotInstaller'
import SegmentInstaller from '../services/SegmentInstaller'
import ShopifyInstaller from '../services/ShopifyInstaller'
import InstallEduTooltip from './InstallEduTooltip'
import GDPRMessage from '../../GDPRMessage'
import Access, { Gates } from 'utils/Access'

const logoSrc = {
  javascript: require('!svg-inline?removeTags=true!images/svg/js-install-icon.svg'),
  wordpress: require('!svg-inline?removeTags=true!images/logos/wordpress-text-logo.svg'),
  drupal: require('!svg-inline?removeTags=true!images/logos/drupal-text-logo.svg'),
  hubspot: require('!svg-inline?removeTags=true!images/logos/HubSpot.svg'),
  segment: require('!svg-inline!images/svg/segment-logo.svg'),
  shopify: require('!svg-inline?removeTags=true!images/logos/shopify-logo.svg'),
}

const generateServices = () => {
  const Services = {
    javascript: {
      title: (
        <div className="flex" style={{ alignItems: 'center' }}>
          {renderLogoSVG(logoSrc.javascript)} <div style={{ marginLeft: 6 }}>JavaScript</div>
        </div>
      ),
      Service: JavaScriptInstaller
    },
    wordpress: {
      title: renderLogoSVG(logoSrc.wordpress),
      Service: WordPressInstaller
    },
    segment: {
      title: renderLogoSVG(logoSrc.segment),
      Service: SegmentInstaller
    },
    shopify: {
      title: renderLogoSVG(logoSrc.shopify),
      Service: ShopifyInstaller
    },
    drupal: {
      title: renderLogoSVG(logoSrc.drupal),
      Service: DrupalInstaller
    }
  }

  if (Access.hasGates(Gates.HUBSPOT_INSTALL)) {
    // temporarliy removing this to see if customers notice. If not, remove permanently
    // giving back the ability if gated so CSMs can work with customer's already having this installed
    Services.hubspot = {
      title: renderLogoSVG(logoSrc.hubspot),
      Service: HubSpotInstaller
    }
  }

  return Services
}


class InstallPage extends Component {

  renderServices = () => {
    const { integrationStates } = this.props
    return _map(generateServices(), ({ Service, title }, serviceName) => {
      const isConnected = integrationStates[serviceName]
      return (
        <Accordion key={serviceName} title={title} isConnected={isConnected}>
          <Service isConnected={isConnected} />
        </Accordion>
      )
    })
  }

  render() {
    return (
      <div>
        <InstallEduTooltip/>
        {this.renderServices()}
        <div className="gdpr-message-wrapper">
          <GDPRMessage/>
        </div>
      </div>
    )
  }
}

export default makeDefaultFailedContainer(InstallPage, {
  listenTo: ['stores.IntegrationsStore'],
  fetch: {
    integrationStates() {
      return this.app.stores.IntegrationsStore.fetchIntegrationStates()
    },
  },
})



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/pages/install.js